import React from 'react'
import { Row, Col } from 'antd'
import { translate } from 'react-i18next'
import { IconHelper } from '../../helpers'
// import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
import _ from 'lodash'
import moment from 'moment'


const Success = ({ t }) => {

    const { IconSuccessMembership } = IconHelper
    const language = useSelector(state => state.language)
    const CancelMem = useSelector(state => state.cancelMemberShip.data.data)

    // const handleFREE = () => {
    //     if (language === "th") {
    //         return (
    //             <>
    //                 VROOM ของคุณถูกปรับไปใช้งาน <span style={{ color: "#FF0000" }}>FREE</span> แพคเกจ
    //             </>
    //         )
    //     } else if (language === "en") {
    //         return (
    //             <>
    //                 Your VROOM has been switched to <span style={{ color: "#FF0000" }}>FREE</span>
    //             </>
    //         )
    //     } else {
    //         return (
    //             <>
    //                 您的VROOM已切换为 <span style={{ color: "#FF0000" }}>FREE</span>
    //             </>
    //         )
    //     }
    // }

    const handleDMY = () => {
        const { expireDate } = CancelMem
        if (!_.isEmpty(expireDate)) {
            if (language === "th") {
                return moment(expireDate).add(543, 'year').format('DD/MM/YYYY')
            } else if (language === "en") {
                return moment(expireDate).format('DD/MM/YYYY')
            } else {
                return moment(expireDate).format('LL')
            }
        } else {
            return t("modal_cancel_membership.d-m-y")
        }

        // const { expireDate } = CancelMem
        // if (!_.isEmpty(expireDate)) {
        //     return formatDateThai(expireDate, language)
        // } else {
        //     return t("modal_cancel_membership.d-m-y")
        // }

    }

    const backToProfile = () => {
        window.location.href = "/portal/profile"
    }

    return (
        <div>
            <section className="secMembership">
                <Row>
                    <Col span={24} className="success-title">
                        <h1>{t("modal_cancel_membership.success")}</h1>

                    </Col>
                </Row>
                <Row type="flex" justify="center">
                    <Col xs={18} sm={16} md={16} lg={8}>
                        <div className="success-card">
                            <div className="icon-success">
                                <IconSuccessMembership style={{ marginTop: "20px" }} />
                            </div>
                            <div className="tag-color">
                                {t("modal_cancel_membership.freepackage")}
                                {/* {handleFREE()} */}
                            </div>
                            <div className="text-detail">
                                {t("modal_cancel_membership.freepackagedetail")}{handleDMY()}
                                {/* <p>{t("modal_cancel_membership.d-m-y")}</p> */}
                                {/* <p>{handleDMY()}</p> */}

                                <div className="back-to-history">
                                    {/* {t("modal_cancel_membership.back")} <Link to={"/portal/profile"} style={{ color: "#FF0000" }}><u>{t("modal_cancel_membership.historyprivate")}</u></Link> */}
                                    {t("modal_cancel_membership.back")} <div onClick={backToProfile} style={{ color: "#FF0000", cursor: "pointer", display: "inline" }}><u>{t("modal_cancel_membership.historyprivate")}</u></div>
                                </div>
                            </div>

                        </div>

                    </Col>
                </Row>
            </section>
        </div>

    )
}

export default translate()(Success)
